import { formatToFirstNonZero } from '@/shared/utils/format/formatToFirstNonZero';
import { toExponential } from '@/shared/utils/format/toExponential';
import { addNumberSuffix } from '@/shared/utils/format/addNumberSuffix';

export const formatNumber = (value: number, precision?: number): string => {
  if (value < 0) return `-${formatNumber(-value, precision)}`;
  if (value === 0) return '0';
  if (!Number.isFinite(value)) return '0';
  if (value > 1e15) return toExponential(value);
  if (value > 1e12) return addNumberSuffix(value / 1e12, 'T', precision);
  if (value > 1e9) return addNumberSuffix(value / 1e9, 'B', precision);
  if (value > 1e6) return addNumberSuffix(value / 1e6, 'M', precision);
  if (value > 1e4) return addNumberSuffix(value / 1e3, 'K', precision);

  if (value > 100) return formatToFirstNonZero(value, precision || 0);
  if (value > 10) return formatToFirstNonZero(value, precision || 2);
  if (value > 1) return formatToFirstNonZero(value, precision || 5);
  if (value < 1) return formatToFirstNonZero(value, precision || 5);

  return formatToFirstNonZero(value);
};
